const fitsWithIcons: { [key: string]: string } = {
    fisk: 'icons/fish.svg',
    'lyst kjøtt': 'icons/light-meat.svg',
    skalldyr: 'icons/shellfish.svg',
    aperitiff: 'icons/aperitiff.svg',
    ost: 'icons/cheese.svg',
    storvilt: 'icons/big-game.svg',
    svin: 'icons/pork.svg',
    grønnsaker: 'icons/vegetables.svg',
    dessert: 'icons/dessert.svg',
    storfe: 'icons/cow.svg',
    'lam og sau': 'icons/sheep.svg',
    småvilt: 'icons/rabbit.svg'
};

export function getIconForFitsWith(fitsWith: string): string {
    return fitsWithIcons[fitsWith.toLowerCase()] || 'icons/circle-minus.svg';
}
